import { Injectable } from '@angular/core';

import { Action, Actions, State, StateContext } from '@ngxs/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ReferralsTerm } from '@recruitee/http/types';

import { HttpApiService } from '../../../core/http-api.service';
import { EntityStateHelpers, EntityUpdateStrategy, IEntityState } from '../../../core/state';
import { EntityState } from '../../../core/state/entity-state';
import { LoadReferralsTerms } from './terms.actions';

type RepositoryType = IEntityState<ReferralsTerm>;

@State<RepositoryType>({
  name: 'terms',
  defaults: EntityStateHelpers.createDefaultState(),
})
@Injectable()
export class ReferralsPortalTermsRepo extends EntityState<ReferralsTerm>() {
  constructor(private actions$: Actions, private httpApi: HttpApiService) {
    super(actions$, EntityUpdateStrategy.update);
  }

  @Action(LoadReferralsTerms)
  public loadReferralsTerm(
    ctx: StateContext<RepositoryType>,
    action: LoadReferralsTerms,
  ): Observable<any> {
    this.markAsLoading(ctx, action);
    return this.httpApi
      .get('/terms')
      .pipe(tap((response: any) => this.saveMany(ctx, action, response.terms)));
  }
}
